<template>
  <div class="bg-primary-950 text-white rounded-lg relative flex flex-col h-full hover:bg-secondary transition-colors">
    <TImage
      :src="image.src"
      :alt="image.alt"
      class="rounded-t-lg"
    />
    <div class="p-4 flex flex-1 flex-col gap-4">
      <p class="font-semibold">
        {{ title }}
      </p>

      <a
        :href="to"
        target="_blank"
        class="mt-auto font-semibold underline hover:no-underline flex items-center gap-2"
        @click.prevent="handleClick"
      >
        <span class="absolute inset-0" />
        {{ cta }}
        <TIcon
          :icon="['fas', 'chevron-right']"
          size="sm"
        />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  image: {
    src: string
    alt?: string
  }
  title: string
  to: string
  cta: string
}>()

const { pageSource } = usePageSource()

async function handleClick() {
  trackCTAClicked({
    cta: props.cta,
    pageSource: pageSource.value,
  })

  await navigateTo(props.to, {
    open: {
      target: '_blank',
    },
  })
}
</script>
